/**
 * Eid Al Etihad 55 scarf designs — the single source of truth for names and colors.
 * Gift boxes reuse these through their `design` number, so a color changed here
 * changes the scarf card, the box card, the preview and the color dots together.
 *
 *  tint   light background behind the scarf / box
 *  dot    the design's main color (small square + color dots in the form)
 */

export interface ScarfDesign {
  tint: string;
  dot: string;
  en: [title: string, description: string];
  ar: [title: string, description: string];
}

export const EID55_SCARVES: ScarfDesign[] = [
  {
    tint: "#F3F0E8",
    dot: "#FFFFFF",
    en: ["City streets", "White with everyday street life"],
    ar: ["شوارع المدينة", "أبيض بمشاهد الحياة اليومية"],
  },
  {
    tint: "#E2D6E4",
    dot: "#C9B6CC",
    en: ["The parade", "Lilac with balloons and the flag car"],
    ar: ["المسيرة", "ليلكي بالبالونات وسيارة العلم"],
  },
  {
    tint: "#F1C9AE",
    dot: "#D9824F",
    en: ["Ayyala & flags", "Coral with ghaf trees and dancers"],
    ar: ["العيّالة والأعلام", "مرجاني بأشجار الغاف والعيّالة"],
  },
  {
    tint: "#EFE9D8",
    dot: "#E9E2CF",
    en: ["Heritage homes", "Sand with houses and the arch"],
    ar: ["البيوت التراثية", "رملي بالبيوت والبوابة"],
  },
  {
    tint: "#D9EBF2",
    dot: "#CBE3EF",
    en: ["Coast & dhows", "Sky blue with dhows and bougainvillea"],
    ar: ["الساحل والقوارب", "سماوي بالقوارب والجهنمية"],
  },
  {
    tint: "#BFE0DA",
    dot: "#1F9A8C",
    en: ["Those who serve", "Teal with the armed forces"],
    ar: ["حماة الوطن", "تركوازي بالقوات المسلحة"],
  },
  {
    tint: "#FBE8B6",
    dot: "#F7D57D",
    en: ["Desert camp", "Yellow with the tent and horses"],
    ar: ["المخيّم", "أصفر بالخيمة والخيول"],
  },
  {
    tint: "#D3E2C8",
    dot: "#5E844F",
    en: ["Oasis wildlife", "Olive with trees and animals"],
    ar: ["حياة الواحة", "زيتي بالأشجار والحيوانات"],
  },
  {
    tint: "#F8D3B6",
    dot: "#EE9050",
    en: ["Dunes & camels", "Orange with the desert and camels"],
    ar: ["الكثبان والجمال", "برتقالي بالصحراء والجمال"],
  },
  {
    tint: "#E9E9EC",
    dot: "#CE1126",
    en: ["UAE flag scarf", "The national flag colors, worn as a stole"],
    ar: ["وشاح العلم", "ألوان علم الدولة على شكل وشاح"],
  },
];
